module.exports = __webpack_public_path__ + "static/media/marketingandAudiencelandscaping-01.b3f5fa52.png";